import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../../MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";
// namespace SlotGames {
    export class MundoMistico_2Screen extends SlotGameType1_2Screen {
        //protected panelFactory: IPanelFactory = new MundoMisticoPanelFactory();
        protected override helpFactory: IHelpFactory = new MundoMisticoHelpFactory();
        protected override panelColor: ButtonColors ={
			backgroundButtonColor: "linear-gradient(rgb(13, 4, 0),rgb(38, 8, 1), rgb(89, 9, 2),rgb(38, 8, 1),rgb(13, 4, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
		}
        
        //LED COLOR
        protected override ColorLed:string="173,83,255\n";
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "MundoMistico");
            this.spinnableReelsParams.topBorderWidth = 0;
            this.spinnableReelsParams.bottomBorderWidth = 0;
        }

        //SEND COLOR FOR RSA 
        protected override color: RewardColor =
            {
                color: "#F1F0C9",
                coloroutherStroke: "black",
                colorinnerStroke: "#9F8DF4",
            }
    }
    
    //Panel Colorized
    class MundoMisticoPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new MundoMisticoPanel(params);
        }
    }

    class MundoMisticoPanel extends Panel {
        // protected override ButtonBackground(): ButtonColors {
        //     let color: ButtonColors = {
        //         backgroundButtonColor: "linear-gradient(rgb(28, 3, 38),rgb(115, 6, 77), rgb(217, 108, 159),rgb(115, 6, 77),rgb(28, 3, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        //         linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
        //     };

        //     return color;
        // }

    }
    class MundoMisticoHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new MundoMisticoHelp(params);
        }
    }

    class MundoMisticoHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(13, 4, 0),rgb(38, 8, 1), rgb(89, 9, 2),rgb(38, 8, 1),rgb(13, 4, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }


// }